// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"dfc7d834","488":"a289eb4f","977":"86d65106"}[chunkId] + ".chunk.js";
};